import { createContext, useContext, useMemo, useState } from "react";

const ProductSeoContext = createContext(null);

export function ProductSeoProvider({ children }) {
  const [productSeo, setProductSeo] = useState(null);

  const value = useMemo(
    () => ({ productSeo, setProductSeo }),
    [productSeo],
  );

  return (
    <ProductSeoContext.Provider value={value}>
      {children}
    </ProductSeoContext.Provider>
  );
}

export function useProductSeo() {
  const context = useContext(ProductSeoContext);
  if (!context) {
    throw new Error("useProductSeo must be used within ProductSeoProvider");
  }
  return context;
}
